import React from "react";
import * as PDF from "@react-pdf/renderer";
import moment from "moment";


type CreatePDFTable = Array<{ [key: string]: number | string }>;
export type PdfFromGridProps = {
  data: CreatePDFTable;
  title: string;
};

export default function PdfFromGrid({
  data,
  title,
}: PdfFromGridProps) {
  PDF.Font.register({
    family: "Roboto",
    src: "https://cdnjs.cloudflare.com/ajax/libs/materialize/0.98.1/fonts/roboto/Roboto-Regular.ttf",
  });
  const styles = PDF.StyleSheet.create({
    headerContainer: {
      width: "100%",
      padding: 15,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 10,
      fontFamily: "Roboto",
    },
    logo: {
      width: 100,
    },
    bold: {
      fontWeight: 600,
    },
    label: {
      fontSize: 12,
    },
    labelContainer: {
      width: "100%",
      height: "auto",
      gap: 5,
      justifyContent: "center",
    },
    title: {
      marginTop: "20px",
      alignSelf: "center",
      borderBottom: "1px solid black",
      fontSize: "14px",
      marginBottom: 20,
    },
    table: {
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      margin: "auto",
      flexDirection: "row",
    },
    tableCol: {
      width: `${100 / Object.keys(data[0]).length}%`,
      borderStyle: "solid",

      alignItems: "center",
      justifyContent: "center",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCell: {
      margin: "auto",
      display: "flex",
      marginTop: 5,
      textAlign: "center",
      fontSize: 7,
    },
    pageNumber: {
      position: "absolute",
      bottom: 10,
      left: 0,
      fontSize: 10,
      right: 0,
      textAlign: "center",
      color: "black",
    },
  });

  const createPDFTable = <Type extends CreatePDFTable>(
    items: Type
  ): JSX.Element | JSX.Element[] => {
    let first = Object.keys(items[0]);

    const headers = first?.map((item) => (
      <PDF.View style={styles.tableCol}>
        <PDF.Text style={styles.tableCell}>{item}</PDF.Text>
      </PDF.View>
    ));
    const content = items.map((item, index) => {
      const row = Object.values(item).map((item) => (
        <PDF.View style={styles.tableCol}>
          <PDF.Text style={styles.tableCell}>{item}</PDF.Text>
        </PDF.View>
      ));
      return (
        <PDF.View
          style={{
            ...styles.tableRow,
            backgroundColor: index % 2 == 0 ? "lightgray" : "white",
          }}
        >
          {row}
        </PDF.View>
      );
    });
    return (
      <PDF.View style={styles.table}>
        <PDF.View style={styles.tableRow}>{headers}</PDF.View>
        {content}
      </PDF.View>
    );
  };

  const tableContent = createPDFTable(data);

  return (
    <PDF.Document title={title}>
      <PDF.Page style={{ paddingBottom: 20 }} orientation="landscape" size="A4">
        <PDF.View style={styles.headerContainer}>
          <PDF.View style={styles.labelContainer}>
          <PDF.Text style={styles.label}>
              Data de emissão: {moment().format("DD/MM/YYYY HH:mm:ss")}
            </PDF.Text>
          </PDF.View>
          <PDF.Image style={styles.logo} source={"/images/logo-bocchi.png"} />
        </PDF.View>
        <PDF.Text style={styles.title}>{title}</PDF.Text>

        {tableContent}
        <PDF.Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </PDF.Page>
    </PDF.Document>
  );
}
